import { FontAwesome } from '@expo/vector-icons';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import * as React from 'react';
import Colors from '../constants/Colors';
import useColorScheme from '../hooks/useColorScheme';
import AppAnalytics from '../lib/analytics/Analytics';
import FanProfileScreen from '../screens/FanProfile';
import FanCreateProfileScreen from '../screens/FanCreateProfile';
import FanGenresScreen from '../screens/FanGenres';
import ListenScreen from '../screens/FanListen';
import LogoAndLogout from '../components/styled/LogoAndLogout';
import {
  FanTabParamList,
  ListenParamList,
  FanProfileParamList,
} from '../types/types';

const BottomTab = createBottomTabNavigator<FanTabParamList>();

export default function BottomTabNavigator() {
  const colorScheme = useColorScheme();
  return (
    <BottomTab.Navigator
      initialRouteName="Fan"
      tabBarOptions={{ activeTintColor: Colors[colorScheme].tint }}
    >
      <BottomTab.Screen
        name="Listen"
        component={ListenNavigator}
        options={{
          tabBarIcon: ({ color }) => <TabBarIcon name="music" color={color} />,
        }}
      />
      <BottomTab.Screen
        name="Account"
        component={FanProfileNavigator}
        options={{
          tabBarIcon: ({ color }) => <TabBarIcon name="user-o" color={color} />,
        }}
      />
    </BottomTab.Navigator>
  );
}

// You can explore the built-in icon families and icons on the web at:
// https://icons.expo.fyi/
function TabBarIcon(props: { name: string; color: string }) {
  const { color, name } = props;
  return (
    <FontAwesome
      color={color}
      name={name}
      size={25}
      style={{ marginBottom: -3 }}
    />
  );
}

// Each tab has its own navigation stack, you can read more about this pattern here:
// https://reactnavigation.org/docs/tab-based-navigation#a-stack-navigator-for-each-tab
const ListenStack = createStackNavigator<ListenParamList>();

function ListenNavigator() {
  return (
    <ListenStack.Navigator
      screenOptions={{ headerRight: () => <LogoAndLogout /> }}
    >
      <ListenStack.Screen
        name="Discover"
        component={ListenScreen}
        options={{
          headerTitle: 'Listen',
        }}
        listeners={({ route }) => ({
          focus: () => AppAnalytics.sendPageHit(route.name),
        })}
      />
    </ListenStack.Navigator>
  );
}

const ProfileStack = createStackNavigator<FanProfileParamList>();

function FanProfileNavigator() {
  return (
    <ProfileStack.Navigator
      screenOptions={{ headerRight: () => <LogoAndLogout /> }}
    >
      <ProfileStack.Screen
        name="MyAccount"
        component={FanProfileScreen}
        options={{
          headerTitle: 'My Account',
        }}
        listeners={({ route }) => ({
          focus: () => AppAnalytics.sendPageHit(route.name),
        })}
      />
      <ProfileStack.Screen
        name="FanCreateProfile"
        component={FanCreateProfileScreen}
        options={{
          headerTitle: 'Create Your Profile',
        }}
        listeners={({ route }) => ({
          focus: () => AppAnalytics.sendPageHit(route.name),
        })}
      />
      <ProfileStack.Screen
        name="FanGenres"
        component={FanGenresScreen}
        options={{
          headerTitle: 'Fan Genres',
        }}
        listeners={({ route }) => ({
          focus: () => AppAnalytics.sendPageHit(route.name),
        })}
      />
    </ProfileStack.Navigator>
  );
}
